// extracted by mini-css-extract-plugin
module.exports = {"resizer":"react-table_resizer__B9sFy","isResizing":"react-table_isResizing__2sXdS"};